import APP_ACTIONS from '../constants/app-actions';
import localStorageAPI from '../services/local-storage-api';

const municipalities = {
    setAvailableMunicipalities: (availableMunicipalities) => (dispatch, getState) => {
        dispatch({
            type: APP_ACTIONS.SET_AVAILABLE_MUNICIPALITIES,
            payload: availableMunicipalities,
        });
        localStorageAPI.save(getState());
    },
    setCurrentMunicipality: (municipalityId) => (dispatch, getState) => {
        dispatch({
            type: APP_ACTIONS.SET_CURRENT_MUNICIPALITY,
            payload: municipalityId,
        });
        localStorageAPI.save(getState());
    },
    setIsMunicipalityPromptModalOpen: (isOpen) => (dispatch, getState) => {
        dispatch({
            type: APP_ACTIONS.SET_IS_MUNICIPALITY_PROMPT_MODAL_OPEN,
            payload: isOpen,
        });
    },
};

export default municipalities;



/** WEBPACK FOOTER **
 ** ./src/actions/municipalities.js
 **/